@if (warningAoNotApplicable) {
  <div>
    <rask-validation-message-row type="warning" [message]="warningAoNotApplicable">
    </rask-validation-message-row>
  </div>
}

<form [formGroup]="form">
  <rask-selector
    label="Ansvarigt transportföretag"
    formControlName="transportforetag"
    [canDelete]="false"
    [formatter]="tplOutputFormatter"
    [viewFormatter]="tplFormatter"
    [values]="transportforetagAo"
    (change)="setTransportForetag($event)"
    class="w-100">
  </rask-selector>
</form>

@if (deladeArbetsordrar.length > 0) {
  <div class="row ps-3 pe-3">
    <div class="col-12">
      {{ 'TPL_UNCHANGEABLE_ARBETAORDRAR' | translate }}
      <p class="personaType">{{ deladeArbetsordrar.join(', ') }}</p>
    </div>
  </div>
}